export default __webpack_public_path__ + "static/media/Lutzen01.fb6a26b3.jpg";